import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { scItems, scLinks } from './SecurityItems'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Index } from '@/components/layouts/Legal/Index'

const sectionTitle = {
  titleText: 'Information Security Policy',
  subTitleText: '情報セキュリティポリシー',
}

const tSummary = (
  <p>
    トライアルグループ（株式会社トライアルホールディングス及びそのグループ会社）は、情報漏洩リスクに対し、厳重な管理体制を構築することにより、お客様をはじめ社会からの信頼を常に得られるよう、「情報セキュリティポリシー」を策定しました。
    <br />
    今後はこの「情報セキュリティポリシー」を遵守し、さまざまな脅威から情報資産を保護し、かつ適正に取り扱うことにより、情報セキュリティの維持に努めてまいります。
  </p>
)

export const SecurityPage = () => {
  return (
    <>
      <Head
        title="情報セキュリティポリシー"
        description="トライアルホールディングスの情報セキュリティポリシーを掲載しています。"
        ogp={{ type: 'article', url: 'legal/security-policy/' }}
      />
      <SecurityContainer>
        <CompleteTitle>
          <SectionTitle
            color="normal"
            titleText={sectionTitle.titleText}
            subTitleText={sectionTitle.subTitleText}
          />
        </CompleteTitle>
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 70, sp: 35 }} />
        <Index columnGap={70} listType="article" links={scLinks} />
        <Spacer h={{ pc: 70, sp: 40 }} />
        {scItems.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < scItems.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </SecurityContainer>
    </>
  )
}
SecurityPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '法務',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '法務', path: '/legal/' },
    { name: '情報セキュリティポリシー', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const SecurityContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`

const CompleteTitle = styled.div`
  width: 100%;
  margin: 0 auto;
  @media screen and (max-width: 1047px) {
    max-width: 200px;
  }
`
